import { persistCombineReducers } from "redux-persist";
import storage from "redux-persist/lib/storage";
import compressor from "./compressor";
import user from "./user";
import app from "./app";
import canvas from "./canvas";
import { reducers as swalReducers } from "react-redux-sweetalert2";
import { routerReducer } from "react-router-redux";

// user state to be stored in storage, but lets not persist someEmphemeralKey
const storeConfig = {
	key: "primary",
	storage: storage,
	blacklist: ["app", "swal"],
	transforms: [compressor],
	// redux-persist defaults to `throttle: 0`, which means `setInterval(processNextKey, 0)`
	// -- the whole canvas slice gets re-serialised and LZ-compressed after *every*
	// dispatch. Drawing dispatches one UPDATE_KEYFRAME per stroke, so this ran the
	// compressor on multi-MB state on every pen stroke. Coalesce those writes instead.
	throttle: 1000
};

// Combine all the reducers into one
const AnimationIsh = persistCombineReducers(storeConfig, {
	user,
	app,
	canvas,
	routerReducer,
	swal: swalReducers
});

export default AnimationIsh;
